export const TICKET_ORDER_SPREAD = 2 ** 10;
